<div class="overlay">
    <div class="saug-spinner spinner-border text-success" role="status">
        <span class="visually-hidden">{{ loading }}</span>
    </div>
</div>